<template>
  <div class="content">
    <div class="unit" v-if="button == '1'">
      <!-- <div class="share" id="tuijianhaoyou" v-if="info.shareType == '1'" @click="fenxiang = true">
        <img src="../img/ico_share.png" style="width: 0.44rem" />
        <p id="good_detailh5">推荐给好友</p>
      </div> -->
      <div class="share" id="tuijianhaoyou" v-if="info.shareType == '2'" @click="shareShow()">
        <img src="../img/ico_amount.png" style="width: 0.44rem" />
        <p id="good_detailh5">赚佣金</p>
      </div>
      <div class="go flex" id="lijigoumai" v-if="button == '1'" :style="info.goodsStatus == '2'?'background:#888;box-shadow: unset;':''" @click="tongyi()">立即购买</div>
    </div>
    <div class="unit" v-if="button == '2'" :style="goodsBargain.userBargainStatus == '1'?'display: unset':''">
      <div v-if="goodsBargain.userBargainStatus != '1'">
      <div class="share" id="tuijianhaoyou2" v-if="info.shareType == '1'" @click="fenxiang = true">
        <img src="../img/ico_share.png" style="width: 0.44rem" />
        <p id="good_detailh5">推荐给好友</p>
      </div>
      <div class="share" id="tuijianhaoyou2" v-if="info.shareType == '2'" @click="shareShow()">
        <img src="../img/ico_amount.png" style="width: 0.44rem" />
        <p id="good_detailh5">赚佣金</p>
      </div>
      </div>
      <div>
        <!-- 未砍价 -->
        <div class="button"  v-if="goodsBargain.userBargainStatus == '0'">
          <div class="first" @click="tongyi()">
            <p style="padding: 0.22rem 0 0.1rem; font-size: 0.2rem" id="yuanjiagoumai">原价购买</p>
            <p>¥{{ goodsBargain.salePrice }}</p>
          </div>
          <div class="last flex" id="faqikanjiadi" @click="xitongkanjia()">发起砍价</div>
        </div>
        <!-- 砍价成功 待下单-->
        <div v-else-if="goodsBargain.userBargainStatus == '2'">
          <div class="daixiadan_btn" @click="xiadan()">
            <p style="font-size: 0.2rem" id="huodongdijiamai">当前价购买</p>
            <p style="font-size: 0.28rem;line-height:1">¥{{ goodsBargain.currentPrice }}</p>
          </div>
        </div>
        <!-- 砍价成功 待支付-->
        <div v-else-if="goodsBargain.userBargainStatus == '4'">
          <div class="daizhifu_btn">
            <a @click="quxiaodingdan()" id="quxiaodingdan">取消订单</a>
            <a @click="payUrl()" id="lijifukuan">立即付款</a>
          </div>
        </div>
        <!-- 砍价中 分享微信群 分享好友 -->
        <div class="button" style="width: 100%" v-else>
          <div class="left" @click="tongyi()" v-if="goodsBargain.ifAnyTime == '2'">
            <p style="padding: 0.22rem 0 0.1rem; font-size: 0.2rem;font-family: PingFangSC-Medium, PingFang SC;" id="yuanjiagoumai">原价购买</p>
            <p>¥{{ goodsBargain.salePrice }}</p>
          </div>
          <div class="left" @click="xiadan()" v-if="goodsBargain.ifAnyTime == '1'">
            <p style="padding: 0.22rem 0 0.1rem; font-size: 0.2rem;font-family: PingFangSC-Medium, PingFang SC;" id="huodongjiamai">当前价购买</p>
            <p>¥{{ goodsBargain.currentPrice }}</p>
          </div>
          <div class="right" v-if="goodsBargain.wechatAmount != 0 " @click="fenxiang11('fenxiangqun')">
            <p id="fenxiangqun" style="padding: 0.22rem 0 0.1rem; font-size: 0.2rem">分享微信群</p>
            <p>再砍<i>{{goodsBargain.wechatAmount}}</i>元</p>
          </div>
          <div class="right flex" id="good_detailh5" v-if="goodsBargain.wechatAmount == 0" @click="fenxiang11('fenxianghaoyou')">
            <p>召唤好友，帮我砍价</p>
          </div>
      </div>
      </div>
    </div>
    <van-popup v-model="fenxiang" class="fenxiangtishi">
      <div class="wrapper fenxiang">
        <img src="../img/ico_fenxiang.png" style="width: 5rem" />
      </div>
    </van-popup>

     <van-dialog v-model="userTold" :showConfirmButton="false" class="confirm-wrap">
        <section class="confirm-cont">
            <div class="head">用户告知</div>  
            <div class="content" v-html="info.userNotify"></div>    
            <div class="footer">
                <div class="check-wrap">
                    <div class="rs-check" @click="agreement">
                        <img src="../img/defalut-check-icon.png" v-if="checkIcon" alt=""/>
                        <img src="../img/unCheck.png" v-else alt=""/>
                    </div>
                    <div class="text">
                        <span class="tag">同意即表示</span>我已知晓并同意用户告知内容
                    </div>
                </div>
                <div class="agree-button-wrap">
                    <a @click="onCancel()" class="default center-line">不同意</a>
                    <a @click="onSave()" :class="['default',checkIcon?'active':'']">同意</a>
                </div>
            </div>
          <div>
          </div>
        </section>
    </van-dialog>
  </div>
</template>
<script>
export default {
  props: {
    type: String,
    button: String,
    isAgent: String,
    goodsBargain: Object,
    info: Object,
  },
  data() {
    return {
      fenxiang: false,
     // querenkuang:false,
      yuanjia:false,
      userTold:false,
      checkIcon:true,
    };
  },
  computed:{
    querenkuang:function () {
        return this.info.explainNames.some( function( item, index, array ){ 
            return item.explainType == '1'; 
        }) 
    } 

  },
  created() {
  },
  methods: {
    tongyi() {

        if (this.info.canBuy === '0') {
            this.$toast.fail('当前商品不允许店员自己购买');
            return;
        }

      if(this.info.goodsStatus == '2') return
      this.yuanjia = true
      if(this.querenkuang){
      this.$parent.$refs.readAgeer.xieyi("1");
      this.$parent.$refs.readAgeer.xiadanqueren = true;
      //this.xieyi("1");
      //this.xiadanqueren = true;
      let {channel,shareMemberId,sellType,sellLabel,} = this.$route.query;
      this.$nextTick(() => {
        this.$trackFn.load("jiankangqueren", "view_material", {
          page_type: "good_detailh5",
          page_attr:this.info.goodsStatus == '1'?this.goodsBargain.userBargainStatus == '0'?'no_started':this.goodsBargain.userBargainStatus == '3'?'finished':'ongoing':'off_shelf',
          card_type: "informqr",
          card_id:shareMemberId,
          item_id:this.info.skuNo,
          item_type:"product_id",
          sell_type:sellType,
          sell_label:sellLabel,
          sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
          material_type:"popup"
        });
        this.$trackFn.load("jiankangqueren", "view_material", {
          page_type: "good_detailh5",
          page_attr:this.info.goodsStatus == '1'?this.goodsBargain.userBargainStatus == '0'?'no_started':this.goodsBargain.userBargainStatus == '3'?'finished':'ongoing':'off_shelf',
          card_type: "informqr",
          card_id:shareMemberId,
          item_id:this.info.skuNo,
          item_type:"product_id",
          sell_type:sellType,
          sell_label:sellLabel,
          sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
          material_type:"all"
        });
        this.$trackFn.load("jiankangqueren", "view_material", {
          page_type: "good_detailh5",
          page_attr:this.info.goodsStatus == '1'?this.goodsBargain.userBargainStatus == '0'?'no_started':this.goodsBargain.userBargainStatus == '3'?'finished':'ongoing':'off_shelf',
          card_type: "informqr",
          card_id:shareMemberId,
          item_id:this.info.skuNo,
          item_type:"product_id",
          sell_type:sellType,
          sell_label:sellLabel,
          sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
          material_type:"part"
        });
      });
      }else{
        const {userNotify}=this.info
        if (userNotify) {
             this.userTold = true;
        }else{
            this.setPointFn();//埋点
            this.$parent.$refs.readAgeer.orderSubmitUrl()
        }
      }
      let {channel,shareMemberId,sellType,sellLabel,} = this.$route.query;
      this.$trackFn.send("click_material", {
        page_type: "good_detailh5",
        page_attr:this.goodsBargain?(this.info.goodsStatus == '1'?this.goodsBargain.userBargainStatus == '0'?'no_started':this.goodsBargain.userBargainStatus == '3'?'finished':'ongoing':'off_shelf'):'normal',
        item_id:this.info.skuNo,
        item_type:"product_id",
        card_type: "informqr",
        sell_type:sellType,
        sell_label:sellLabel,
        sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
        material_type:"popup"
      });
    },
    //立即购买业务埋点
    // 用户id 商品sku 商品名字 商品售价 商品主类型 商品子类型 店员id 店员名称 门店id 门店名称
    setPointFn(){
        const {memberId} =JSON.parse(sessionStorage.getItem("user"))
        const {skuNo,title,salePrice,productType,productTypeText,productSubtype,productSubtypeText,
            assistantId,
            assistantName,
            storeId,
            storeName,
        } =this.info
        this.$newTrackFn.send('FX_launch_buy_user',{
            member_id:memberId,
            product_sku:skuNo,
            product_name:title,
            product_price:salePrice,
            product_type:`${productType}:${productTypeText}`,
            product_subtype:`${productSubtype}:${productSubtypeText}`,
            assistant_id:assistantId,
            assistant_name:assistantName,
            store_id:storeId,
            store_name:storeName,
        })
    },

    xitongkanjia(){
      this.$emit('noticeParent1','xtkanjia')
      let {
        channel,
        shareMemberId,
        sellType,
        sellLabel,
      } = this.$route.query;
      this.$trackFn.send("click_material", {
        // 点击 - 埋点
        page_type: "good_detailh5",
        page_attr:"no_started",
        card_type: "bottom_bar",
        card_id:shareMemberId,
        item_id:this.info.skuNo,
        item_type:"product_id",
        sell_type:sellType,
        sell_label:sellLabel,
        sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
        material_type:"bargain_start"
      });
    },
    fenxiang11(event){
      this.$emit('noticeParent1',event)
      let {channel,shareMemberId,sellType,sellLabel,} = this.$route.query;
      this.$trackFn.send("click_material", {
        page_type: "good_detailh5",
        page_attr:this.info.goodsStatus == '1'?this.goodsBargain.userBargainStatus == '0'?'no_started':this.goodsBargain.userBargainStatus == '3'?'finished':'ongoing':'off_shelf',
        item_id:this.info.skuNo,
        item_type:"product_id",
        card_type: "bottom_bar",
        card_id:shareMemberId,
        sell_type:sellType,
        sell_label:sellLabel,
        sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
        material_type:event == 'fenxiangqun'?"bargain__group":event == 'fenxianghaoyou'?"bargain_friends":'',
      });
    },
    xiadan(){
      this.yuanjia = false
      if(this.querenkuang){
        this.$parent.$refs.readAgeer.xieyi("1");
        this.$parent.$refs.readAgeer.xiadanqueren = true;
      let {channel,shareMemberId,sellType,sellLabel,} = this.$route.query;
      this.$nextTick(() => {
        this.$trackFn.load("jiankangqueren", "view_material", {
          // 曝光 - 埋点
          page_type: "good_detailh5",
          page_attr:this.button == '1'?'normal':this.info.goodsStatus == '1'?this.goodsBargain.userBargainStatus == '0'?'no_started':this.goodsBargain.userBargainStatus == '3'?'finished':'ongoing':'off_shelf',
          card_type: "informqr",
          card_id:shareMemberId,
          item_id:this.skuNo,
          item_type:"product_id",
          sell_type:sellType,
          sell_label:sellLabel,
          sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
          material_type:"all"
        });
      });
      }else{
        this.$emit('noticeParent1','xiadan')
      }
    },
    quxiaodingdan(){
      this.$emit('noticeParent1','quxiaodingdan')
    },
    payUrl(){
      location.href = this.goodsBargain.payUrl
    },
    shareShow(){
      let href = encodeURIComponent(window.location.href)
      location.href = `${window.location.origin}/distribution/bill?url=${href}`
      let {channel,shareMemberId,sellType,sellLabel,} = this.$route.query;
      this.$trackFn.send("click_material", {
        page_type: "good_detailh5",
        page_attr:this.info.goodsStatus == '1'?this.goodsBargain.userBargainStatus == '0'?'no_started':this.goodsBargain.userBargainStatus == '3'?'finished':'ongoing':'off_shelf',
        item_id:this.info.skuNo,
        item_type:"product_id",
        card_type: "bottom_bar",
        card_id:shareMemberId,
        sell_type:sellType,
        sell_label:sellLabel,
        sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
        material_type:'share',
        material_link:`${window.location.origin}/bill&url${href}`
      });
    },

    agreement(){
        this.checkIcon =!this.checkIcon
    },
    onCancel(){
        this.userTold = false;
    },
    onSave(){
        if (!this.checkIcon) {
          this.$toast('请勾选同意用户告知内容');
          return;
        }
        this.setPointFn();//埋点
        this.userTold = false;
        window.location.href = this.info.orderSubmitUrl;
    }

  },
};
</script>
<style lang="scss" scoped>
.content {
  padding: 40px 30px 50px;
  .read {
    text-align: left;
    font-size: 22px;
    padding-bottom:0.2rem;
    span {
      color: #888888;
    }
    a {
      color: #ff6600;
    }
  }
  .unit {
    display: flex;
    align-items: center;
    justify-content: space-between;
    &.just-center{
      justify-content: center;
    }
    .share {
      font-size: 22px;
      color: #666666;
      text-align: center;
    }
    .go {
      width: 5.2rem;
      padding: 32px 0;
      color: #fff;
      font-size: 32px;
      background: linear-gradient(124deg, #f26b57 0%, #f83a2c 100%);
      box-shadow: 0px 8px 12px 0px rgba(224, 32, 32, 0.2);
      border-radius: 48px;
      line-height: 1;
    }
    .button {
      text-align: center;
      color: #fff;
      display: inline-flex;
      .first,
      .last,
      .left,
      .right {
        font-size: 28px;
        width: 260px;
        height: 96px;
        line-height: 96px;
        p{
font-family: PingFangSC-Medium, PingFang SC;
i{
  font-style: normal;
  font-family: HelveticaNeue-Medium, HelveticaNeue;
  font-size: 28px;
}
        }
      }
      .first,
      .left {
        background: linear-gradient(124deg, #f26b57 0%, #f83a2c 100%);
        box-shadow: 0px 8px 12px 0px rgba(224, 32, 32, 0.2);
        border-radius: 200px 0px 0px 200px;
        p {
          line-height: 1;
          font-size: 28px;
font-family: HelveticaNeue-Medium, HelveticaNeue;
        }
      }
      .last,
      .right {
        background: linear-gradient(135deg, #ffa000 0%, #ff6600 100%);
        box-shadow: 0px 8px 12px 0px rgba(224, 32, 32, 0.2);
        border-radius: 0px 200px 200px 0px;

font-family: PingFangSC-Medium, PingFang SC;
      }
      .left,
      .right {
        width: 50%;
      }
      .right {
        p {
          line-height: 1;
          font-size: 28px;
        }
      }
    }
    .daixiadan_btn{
      background: linear-gradient(124deg, #f26b57 0%, #f83a2c 100%);width:5rem;box-shadow: 0px 0.08rem 0.12rem 0px rgba(224, 32, 32, 0.2);border-radius: 0.48rem;    text-align: center;
    color: #fff;padding: 0.19rem 0;
    }
    .daizhifu_btn{
      a{
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 2.4rem;
        border-radius: 48px;
        font-size: 28px;
        height: 96px;
        &:first-child{
        color: #666666;
        box-shadow: 0px 8px 12px 0px rgba(0, 0, 0, 0.1);
        border: 1px solid #F8F8F8;
        margin-right: 20px;
      }
      &:last-child{
        color: #fff;
        background: linear-gradient(124deg, #F26B57 0%, #F83A2C 100%);
        box-shadow: 0px 8px 12px 0px rgba(224, 32, 32, 0.2);
      }
      }
    }
  }
  .fenxiangtishi {
    left: 62% !important;
    top: 5% !important;
  }
  .flex {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .fuwuxieyi {
    border-radius: 40px 40px 0px 0px !important;
    ::v-deep.van-action-sheet__header {
      text-align: left;
      font-size: 0.36rem;
      font-weight: 600;
      color: #333333;
      padding-left: 0.4rem;
    }
    ::v-deep.van-card {
      background: #fff;
      padding: 0.4rem 0;
      border-top: 1px solid #eee;
    }
    ::v-deep.van-card__title {
      font-size: 0.28rem;
      font-weight: 500;
      color: #333333;
    }
    ::v-deep.van-card__price {
      color: #dd2b1e;
    }
    ::v-deep.van-card__num {
      margin-top: -1.4rem;
      color: #333333;
    }
  }
  .actionSheetContent {
    margin: 0.4rem;
    ::v-deep {
      .van-tab {
        display: block;
        // padding: 0 20px;
        flex: none !important;
      }
      .van-tabs__wrap {
        margin-bottom: 0.4rem;
        //   border-bottom: 1px solid #eee;
      }
      .van-tab__text {
        font-size: 0.3rem;

        font-family: PingFangSC-Medium, PingFang SC;
      }
      .van-tabs__line {
        // width: 30px !important;
      }
    }
    .btn {
      display: flex;
      justify-content: space-between;
      padding-top: 0.5rem;
      a {
        width: 3rem;
        height: 0.88rem;
        font-size: 36px;
        font-family: PingFangSC-Medium, PingFang SC;
        border-radius: 16px;
        &:first-child {
          color: #dd2b1e;
          background: linear-gradient(
            90deg,
            rgba(240, 86, 64, 0.05) 0%,
            rgba(221, 43, 30, 0.05) 100%
          );
        }
        &:last-child {
          color: #ffffff;
          background: linear-gradient(128deg, #f26b57 0%, #dd2b1e 100%);
          box-shadow: 0px 8px 16px 0px rgba(224, 32, 32, 0.3);
        }
      }
    }
  }
}
   .confirm-wrap{
        width: 638px;
        height: 892px;
        background: #FFFFFF;
        border-radius: 24px;
        .head{
            width:100%;
            height: 112px;
            background: linear-gradient(127deg, #00E6C1 0%, #00B899 100%);
            border-radius: 24px 24px 0px 0px;
            font-size: 36px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .content{
            padding: 26px 43px 14px 43px;
            height: 564px;
            font-size: 26px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0,0,0,0.45);
            line-height: 40px;
            overflow-y: scroll;
        }
        .footer{
            width: 638px;
            height: 176px;
            background: #FFFFFF;
            box-shadow: 0px -2px 8px 0px rgba(0,0,0,0.04);
            border-radius: 0px 0px 24px 24px;
            .check-wrap{
                padding-left: 44px;
                height: 76px;
                display: flex;
                flex-direction: row;
                align-items: center;
                line-height: 36px;
                border: 1px solid rgba(0,0,0,0.06);
                .rs-check{
                    width: 32px;
                    height: 32px;
                    img{
                        width: 100%;
                    }
                }
                .text{
                    line-height: 76px;
                    padding-left: 16px;
                    font-size: 26px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    padding-top: 4px;
                }
            }
            .tag{
                font-size: 26px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #00B395;
            }
            .agree-button-wrap{
                display: flex;
                align-items: center;
                text-align: center;
                line-height: 100px;
                .default{
                    flex:1;
                    font-size: 32px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: rgba(0,0,0,0.45);
                }
                .center-line{
                    border-right: 1px solid rgba(0,0,0,0.06);    
                }
                .active{
                    color: #00B395;
                }
            }
        }
    }
</style>
